import React from 'react'
import { FlexColumn, FlexRow } from 'components/common/Containers'
import { Hero } from 'components/common/Hero'
import { H1 } from 'components/common/Texts/H1/H1'
import HeroImage from './images/hero.svg'
import styles from './SEOMetricsHero.module.scss'

const SEOMetricsHero: React.FC = () => {
  return (
    <Hero className={styles.hero}>
      <FlexRow justify="space-between">
        <FlexColumn className={styles.textWrapper} gap="5px">
          <H1>Track SEO Metrics</H1>
          <p>
          Do you want to increase the visibility of your website and improve its rankings? 
          Let&apos;s help you track SEO metrics and optimize your website&apos;s performance with Bishopi&apos;s SEO monitor.
          </p>
        </FlexColumn>

        <HeroImage />
      </FlexRow>
    </Hero>
  )
}

export default SEOMetricsHero
